import React from 'react';
import { UpdateRouteMap } from '@src/features/order/pages/upsert-mission-page/maps';

// The confirm step reuses the first-step (Flight Plan) route view: numbered waypoints,
// terrain awareness and drones, rendered from the stored mission (by missionId).
const ConfirmOrderMap: React.FC = () => <UpdateRouteMap />;

export default ConfirmOrderMap;
